export default {
    client_id: 4,
    grant_type: 'password',
    client_secret: 'q4GZDtfMnNsTHYodO6zsA0SV92ZZMkMr2UaEF8f4',
    scope: ''
}
